import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../../utils/Customer/apiBaseQuery";
import {
  CustomerLoginResponse,
  CustomerOtpResponse,
  GuestLoginResponse,
  IRefreshTokenResponse,
  ScreenResponse,
} from "../../../types/Response/CustomerResponse";
import {
  CUSTOMER_EMAIL_LOGIN,
  CUSTOMER_EMAIL_OTP,
  CUSTOMER_LOGIN,
  CUSTOMER_OTP,
  GET_SCREEN,
  GUEST_LOGIN,

} from "../../../config/apiUrlsCustomer";
import {
  CustomerEmailLoginRequest,
  CustomerEmailOtpRequest,
  CustomerLoginRequest,
  CustomerOtpRequest,
  IGetScreenByNameRequest,
  IRefreshTokenRequest,
} from "../../../types/Request/CustomerRequest";

export const customerAuthAPi = createApi({
  reducerPath: "customerAuthAPi",
  baseQuery: axiosBaseQuery(),

  endpoints: (builder) => ({
    guestLogin: builder.mutation<GuestLoginResponse, any>({
      query: (data) => ({
        url: `${GUEST_LOGIN}`,
        method: "post",
        data: data,
      }),
    }),
    customerLogin: builder.mutation<
      CustomerLoginResponse,
      CustomerLoginRequest
    >({
      query: (data) => ({
        url: `${CUSTOMER_LOGIN}`,
        method: "post",
        data: data,
      }),
    }),
    customerOtp: builder.mutation<CustomerOtpResponse, CustomerOtpRequest>({
      query: (data) => ({
        url: `${CUSTOMER_OTP}`,
        method: "post",
        data: data,
      }),
    }),
        customerEmailLogin: builder.mutation<
      CustomerLoginResponse,
      CustomerEmailLoginRequest
    >({
      query: (data) => ({
        url: `${CUSTOMER_EMAIL_LOGIN}`,
        method: "post",
        data: data,
      }),
    }),
    customerEmailOtp: builder.mutation<CustomerOtpResponse, CustomerEmailOtpRequest>({
      query: (data) => ({
        url: `${CUSTOMER_EMAIL_OTP}`,
        method: "post",
        data: data,
      }),
    }),
    GetScreen: builder.query<ScreenResponse, IGetScreenByNameRequest>({
      query: ({ screenName, clientType }) => ({
        url: `${GET_SCREEN}/${screenName}`,
        method: "get",
        params: {
          clientType,
        },
      }),
    }),
    // refershToken: builder.mutation<IRefreshTokenResponse, void>({
    //   query: (data) => ({
    //     url: `${REFERSH_TOKEN}`,
    //     method: "post",
    //     data: data,
    //   }),
    // }),
  }),
});

export const {
  useGuestLoginMutation,
  useCustomerLoginMutation,
  useCustomerOtpMutation,

  useCustomerEmailLoginMutation,
  useCustomerEmailOtpMutation,
  useLazyGetScreenQuery,
  // useRefershTokenMutation
} = customerAuthAPi;
